import React, { useEffect, useState, useContext } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { withRouter } from 'react-router-dom';
import BottomNav1 from './BottomNav1';
import BottomNav2 from './BottomNav2';
import BottomNav3 from './BottomNav3';
import BottomNav4 from './BottomNav4';
import BottomNav9 from './BottomNav9';
import * as chatApi from 'api/chat';
import { RELIPED_MESSAGE_CHAT_STATUS } from 'config/constants';
import { AuthContext } from '../../context/AuthContext';

function BottomNav(props) {
  const authContext = useContext(AuthContext);
  const [isUnReplied, setIsUnReplied] = useState(false);
  const envUi = authContext.envUi;
  const userProfile = authContext.userProfile;
  const { data: conversations, isLoading } = useQuery(['conversations'], () => chatApi.getConversation());

  useEffect(() => {
    const result = conversations?.data?.some((value) => {
      return (
        value?.messages?.filter(
          (item) => item?.replied === RELIPED_MESSAGE_CHAT_STATUS.UNRELIPED && item?.senderId !== userProfile?.id
        ).length > 0
      );
    });
    if (result) {
      setIsUnReplied(result);
    }
  }, [conversations, userProfile]);

  // Not user profile
  // Not envUi
  // Setting off bottom
  if (!userProfile || !envUi || (envUi && +envUi?.displayBottomNaviMenu !== 0)) {
    return null;
  }

  if (envUi) {
    const footerNav = envUi?.footerNav ?? null;
    switch (footerNav) {
      case 2:
        return (
          <BottomNav2
            location={props.location}
            history={props.history}
            userProfile={userProfile}
            isUnReplied={isUnReplied}
          />
        );
      case 3:
        return <BottomNav3 location={props.location} history={props.history} userProfile={userProfile} />;
      case 4:
        return <BottomNav4 location={props.location} history={props.history} userProfile={userProfile} />;
      case 9:
        return <BottomNav9 location={props.location} history={props.history} userProfile={userProfile} />;
      default:
        return (
          <BottomNav1
            location={props.location}
            history={props.history}
            userProfile={userProfile}
            isUnReplied={isUnReplied}
          />
        );
    }
  }
}

export default withRouter(BottomNav);
